/**
 * @file 路由入口文件
 * @description 只是入口配置，具体路由在 @/config/router.js 配置
 * @date 2021-06-24
 */

import { createRouter, createWebHistory } from 'vue-router';
import config from '@/config/router';
import { locales } from '@/config/site';
import login from './middleware/login';
import locale from './middleware/locale';
import preRequest from './middleware/preRequest';

// 查找到配置中有路径，并且没有子路径的
const rules = config.filter((item) => item.path && !item.children);
const routes = [];

// 根据支持的语言映射成路由
if (locales.length === 1) {
    rules.forEach((item) => {
        const route = {
            ...item,
            path: `/${item.path.replace(/^\/+/, '')}`,
            meta: {
                layout: 'Default',
                ...item.meta,
            },
        };
        if (item.alias) {
            route.alias = `/${item.alias.replace(/^\/+/, '')}`;
        }
        routes.push(route);
    });
} else {
    locales.forEach((key) => {
        rules.forEach((item) => {
            const route = {
                ...item,
                path: `/${key}/${item.path.replace(/^\/+/, '')}`,
                meta: {
                    layout: 'Default',
                    ...item.meta,
                },
            };
            if (item.alias) {
                route.alias = `/${key}/${item.alias.replace(/^\/+/, '')}`;
            }
            routes.push(route);
        });
    });
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 锚点定位
        if (to.hash) {
            return {
                selector: to.hash,
            };
        }

        return savedPosition || { left: 0, top: 0 };
    },
});

// 安装导航守卫
const installEach = (context) => {
    if (Array.isArray(context)) {
        context.forEach((item) => router.beforeEach(item));
    } else {
        if (Array.isArray(context.beforeEach)) {
            context.beforeEach.forEach((item) => router.beforeEach(item));
        }

        if (Array.isArray(context.afterEach)) {
            context.afterEach.forEach((item) => router.afterEach(item));
        }
    }
};

installEach(login);
installEach(locale);
installEach(preRequest);

export default router;
